import HttpRequest from './core/http_request';

class MasterProvider extends HttpRequest {
  getWaterSource () {
    return this.request('get', '/masterdata/watersource');
  }
}

export default MasterProvider;
